import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../../components/Button/Button'
import { Logo } from '../../components/Logo/Logo'
import TextField from '../../components/TextField/TextField'
import validator from 'validator'
import { serverConn } from '../../API/apiRequest'
import ReactGA from 'react-ga'
const ForgetPassword: React.FC = (props)=>{
    
    const [email, setEmail] = useState('')
    const [err, setErr] = useState('')
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')

    useEffect(()=>{
        ReactGA.pageview(window.location.pathname)
    },[])

    const onChangeEmail = ({target}: React.ChangeEvent<HTMLInputElement>)=>{
        setEmail(target.value)
        setErr('')
        setSuccess('')
    }

    const onSent = async()=>{
       try{
          if(email.trim() === '' || !validator.isEmail(email)){
              return setErr('من فضلك اكتب البريد الإلكتروني بشكل صحيح')
          }
          setLoading(true)
          let response = await serverConn.post('/forget', {email})
          setEmail('')
          setLoading(false)
          
          if(response.status === 201)
           return setSuccess('تم ارسال اعادة تعيين كلمة المرور')
          if(response.status === 200)
           return setSuccess('تم الإرسال قم بفحص البريد الإلكتروني')

       }catch(e: any){
            setLoading(false)
            if(e.response && e.response.status === 404)
            return setErr('البريد الإلكتروني غير مسجل')
            console.log(e)
       }

    }

    return(
        <div style={{display: 'flex', backgroundColor: '#1D252D', minHeight: '100vh', alignItems: 'flex-start', flexDirection: 'column'}}>
            <Link to='/' style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 20}}>
                <Logo />
            </Link>
            <div style={{width: '100%', marginTop: 25}}>
                <h2 style={{color: '#fff', textAlign: 'center'}}>
                    نسيت كلمة المرور
                </h2>
            </div>
            <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%', marginTop: 30}}>
            <div style={{backgroundColor: '#343a40', padding: 30, borderRadius: 5}}>
            <div style={{
                display: 'flex', 
                justifyContent: 'flex-start', 
                alignItems: 'flex-end', 
                flexDirection: 'column',
            }}>
                <p style={{color: '#fff', margin: 0, padding: 0}}>البريد الإلكتروني</p>
                <TextField 
                  placeholder='البريد الإلكتروني'
                  handleChange={onChangeEmail}
                  disabled={loading}
                />
            </div>
            </div>
            {err && <p style={{color: 'tomato', margin: 0, padding: 0, marginTop: 10}}>{err}</p>}
            {success && <p style={{color: '#6EB66C', margin: 0, padding: 0, marginTop: 10}}>{success}</p>}
            <Button loading={loading} style={{marginTop: 20}} onPress={onSent}>ارسال</Button>
            </div>
        </div>
    )
}

export default ForgetPassword